import * as React from 'react';

const ServiceDetails = ({ service = null, onChange }) => {

    const onFieldChange = ({ 
        target: { 
            value, 
            dataset: { 
                property,
            }, 
        },
    }) => {
        onChange({ property, value });
    };


    return (
        <React.Fragment>            
            <div className="form-group">
                <label>Name<span className="input-required"> *</span></label>
                <input 
                    className="form-control service-name"
                    defaultValue={service === null ? '' : service.developerName}
                    data-property="name"
                    onChange={onFieldChange}
                />                    
            </div>
            <div className="form-group">
                <label>The URL for this Service<span className="input-required"> *</span></label>
                <input 
                    className="form-control service-url" 
                    defaultValue={service === null ? '' : service.uri}
                    data-property="url"
                    onChange={onFieldChange}
                />                    
            </div>
            <p>Provide a username & password if requests to the service url require authentication. This is optional.</p>
            <div className="form-group">
                <label>Username</label>
                <input 
                    className="form-control service-username" 
                    defaultValue={service === null ? '' : service.httpAuthenticationUsername}
                    autoComplete="new-password"
                    data-property="username"
                    onChange={onFieldChange}
                />                    
            </div>
            <div className="form-group">
                <label>Password</label>
                <input 
                    type="password" 
                    className="form-control service-password" 
                    defaultValue=""
                    autoComplete="new-password"
                    data-property="password"
                    onChange={onFieldChange}
                />                    
            </div>
            <div className="form-group">
                <label>Comments about this Service</label>
                <textarea 
                    maxLength="1000" 
                    rows="3" 
                    className="form-control service-comments" 
                    defaultValue={service === null ? '' : service.developerSummary}
                    data-property="comments"
                    onChange={onFieldChange}
                />
            </div>
        </React.Fragment>
    );
};

export default ServiceDetails;
